<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="工单号">
                <a-input v-model="queryParam.id" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="厂家寄回快递单号">
                <a-input v-model="queryParam.returnMailNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户寄出快递单号">
                <a-input v-model="queryParam.mailNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="企业名称">
                <a-input v-model="queryParam.companyName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="寄件人">
                <a-input v-model="queryParam.senderName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="设备MAC地址">
                <a-input v-model="queryParam.macAddress" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="处理状态">
                <a-select placeholder="请选择" v-model="queryParam.repairStatus" style="width: 100%" allow-clear>
                  <a-select-option :value="0">待收货</a-select-option>
                  <a-select-option :value="1">待审核</a-select-option>
                  <a-select-option :value="2">待支付</a-select-option>
                  <a-select-option :value="3">维修中</a-select-option>
                  <a-select-option :value="4">待寄回</a-select-option>
                  <a-select-option :value="5">已邮寄</a-select-option>
                  <a-select-option :value="6">已完成</a-select-option>
                  <a-select-option :value="10">已取消</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 18" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button
          type="danger"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['f1ad16249f088841bd0fb84210e9b21dr:0:r']"
        >
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['f1ad16249f088841bd0fb84210e9b21de:0:e']">
          <a-icon type="download" />导出
        </a-button>
      </div>

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <span slot="id" slot-scope="text, record">
          <a-tooltip :title="record.id || '--'">
            <span class="text-ellipsis">{{ record.id || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="returnMailNo" slot-scope="text, record">
          <a-tooltip :title="record.returnMailNo || '--'">
            <span class="text-ellipsis">{{ record.returnMailNo || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="mailNo" slot-scope="text, record">
          <a-tooltip :title="record.mailNo || '--'">
            <span class="text-ellipsis">{{ record.mailNo || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="companyName" slot-scope="text, record">
          <a-tooltip :title="record.companyName || '--'">
            <span class="text-ellipsis">{{ record.companyName || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="macAddress" slot-scope="text, record">
          <a-tooltip :title="record.macAddress || '--'">
            <span class="text-ellipsis">{{ record.macAddress || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="problemType" slot-scope="text, record">
          <a-tooltip :title="record.problemType || '--'">
            <span class="text-ellipsis">{{ record.problemType || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="warrantyFlag" slot-scope="text, record">
          <a-tag :color="record.warrantyFlag === 1 ? 'green' : 'red'">
            {{ record.warrantyFlag === 1 ? '是' : '否' }}
          </a-tag>
        </span>
        <span slot="repairStatus" slot-scope="text, record">
          <a-tag :color="getStatusColor(record)">
            {{ getStatusText(record) }}
          </a-tag>
        </span>
        <span slot="senderName" slot-scope="text, record">
          <a-tooltip :title="record.senderName || '--'">
            <span class="text-ellipsis">{{ record.senderName || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="handleType" slot-scope="text, record">
          <span v-if="record.handleType == 0">维修</span>
          <span v-if="record.handleType == 1">换新</span>
        </span>
        <span slot="createTime" slot-scope="text, record">
          <a-tooltip :title="record.createTime || '--'">
            <span class="text-ellipsis">{{ record.createTime || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['f1ad16249f088841bd0fb84210e9b21dq:0:q']">详情</a>
          <a-divider type="vertical" />

          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['f1ad16249f088841bd0fb84210e9b21dr:0:r']">
                <a @click="handleDelete(record)">删除</a>
              </a-menu-item>
              <a-menu-item v-if="record.repairStatus === 0" v-hasPermi="['f1ad16249f088841bd0fb84210e9b21dd:0:d']">
                <a @click="handleConfirmReceipt(record)">确认收货</a>
              </a-menu-item>
              <a-menu-item v-if="record.repairStatus === 1" v-hasPermi="['386f2835aadfb04549f51e9290e3f444d:0:d']">
                <a @click="handleRepairItem(record)">添加维修清单</a>
              </a-menu-item>
              <a-menu-item v-if="record.repairStatus === 2 && record.payStatus === 0">
                <a @click="handleSendSms(record)">发送短信</a>
              </a-menu-item>
              <a-menu-item
                v-hasPermi="['f1ad16249f088841bd0fb84210e9b21dd:1:d']"
                v-if="record.repairStatus === 2 && record.payStatus === 1"
              >
                <a @click="handleStartRepair(record)">开始维修</a>
              </a-menu-item>
              <a-menu-item v-if="record.repairStatus === 3" v-hasPermi="['f1ad16249f088841bd0fb84210e9b21dd:3:d']">
                <a @click="handleFinishRepair(record)">维修完成</a>
              </a-menu-item>
              <a-menu-item v-if="record.repairStatus === 4" v-hasPermi="['f1ad16249f088841bd0fb84210e9b21dd:2:d']">
                <a @click="handleConfirmShipment(record)">确认寄回</a>
              </a-menu-item>
              <a-menu-item v-if="record.repairStatus === 5" v-hasPermi="['f1ad16249f088841bd0fb84210e9b21dd:2:d']">
                <a @click="handleEndRepair(record)">工单完结</a>
              </a-menu-item>
              <a-menu-item v-if="record.repairStatus === 0" v-hasPermi="['f1ad16249f088841bd0fb84210e9b21dd:0:c']">
                <a @click="handleCancel(record)">取消订单</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <detail ref="detailDrawer" />
    <complete-repair ref="completeRepairDrawer" @ok="getList" />
    <confirm-shipment ref="confirmShipmentDrawer" @ok="getList" />
    <confirm-receipt ref="confirmReceiptDrawer" @ok="getList" />
    <repair-item ref="repairItemDrawer" @ok="getList" />
    <start-repair ref="startRepairDrawer" @ok="getList" />
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, sendSms, cancelRepair, endRepair } from '@/api/fix/devRepair'
import moment from 'moment'
import detail from './modules/detail.vue'
import CompleteRepair from './modules/completeRepair.vue'
import ConfirmReceipt from './modules/ConfirmReceipt.vue'
import RepairItem from './modules/repairItem.vue'
import StartRepair from './modules/StartRepair.vue'
import ConfirmShipment from './modules/ConfirmShipment.vue'
export default {
  name: 'DevRepair',
  components: {
    detail,
    CompleteRepair,
    ConfirmReceipt,
    RepairItem,
    StartRepair,
    ConfirmShipment,
  },
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],

      queryParam: {
        pageNum: 1,
        pageSize: 10,
        id: undefined,
        returnMailNo: undefined,
        mailNo: undefined,
      },
      total: 0,
      value: [],
      advanced: false,
      loading: false,
      tableSize: 'default',
      tableBordered: true,
      columns: [
        {
          title: '工单号',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: { customRender: 'id' },
          align: 'center',
          width: 120,
        },
        {
          title: '寄回单号',
          dataIndex: 'returnMailNo',
          key: 'returnMailNo',
          scopedSlots: { customRender: 'returnMailNo' },
          align: 'center',
          width: 110,
        },
        {
          title: '寄出单号',
          dataIndex: 'mailNo',
          key: 'mailNo',
          scopedSlots: { customRender: 'mailNo' },
          align: 'center',
          width: 110,
        },
        {
          title: '企业名称',
          dataIndex: 'companyName',
          key: 'companyName',
          scopedSlots: { customRender: 'companyName' },
          align: 'center',
          width: 100,
        },
        {
          title: '寄件人',
          dataIndex: 'senderName',
          key: 'senderName',
          scopedSlots: { customRender: 'senderName' },
          align: 'center',
          width: 80,
        },
        {
          title: '故障类型',
          dataIndex: 'problemType',
          key: 'problemType',
          scopedSlots: { customRender: 'problemType' },
          align: 'center',
          width: 120,
        },
        {
          title: '处理方式',
          dataIndex: 'handleType',
          key: 'handleType',
          scopedSlots: { customRender: 'handleType' },
          align: 'center',
          width: 80,
        },
        {
          title: '保修期内',
          dataIndex: 'warrantyFlag',
          key: 'warrantyFlag',
          scopedSlots: { customRender: 'warrantyFlag' },
          align: 'center',
          width: 80,
        },
        {
          title: '处理状态',
          dataIndex: 'repairStatus',
          key: 'repairStatus',
          scopedSlots: { customRender: 'repairStatus' },
          align: 'center',
          width: 80,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 90,
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 120,
        },
      ],
    }
  },
  methods: {
    getStatusText(record) {
      const status = record.repairStatus
      if (status === 2) {
        if (record.payStatus === 0) {
          return '待支付'
        } else {
          return '已支付'
        }
      }
      const statusMap = {
        0: '待收货',
        1: '待审核',
        3: '维修中',
        4: '待寄回',
        5: '已邮寄',
        6: '已完成',
        10: '已取消',
      }
      return statusMap[status] || '未知'
    },
    getStatusColor(record) {
      const status = record.repairStatus
      if (status === 2) {
        if (record.payStatus === 0) {
          return 'gold'
        } else {
          return 'green'
        }
      }
      const colorMap = {
        0: 'orange',
        1: 'blue',
        3: 'purple',
        4: 'cyan',
        5: 'geekblue',
        6: 'green',
        10: 'grey',
      }
      return colorMap[status] || 'grey'
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },

    handleConfirmReceipt(record) {
      this.$refs.confirmReceiptDrawer.init(record)
    },

    handleRepairItem(record) {
      this.$refs.repairItemDrawer.init(record)
    },

    handleSendSms(record) {
      var that = this
      this.$confirm({
        title: '发送短信通知',
        content: '确认向客户发送返修费用支付通知短信吗？',
        onOk() {
          return sendSms({ id: record.id })
            .then(() => {
              that.$message.success('短信发送成功')
            })
            .catch(() => {})
        },
        onCancel() {},
      })
    },

    handleStartRepair(record) {
      this.$refs.startRepairDrawer.init(record)
    },

    handleConfirmPayment(record) {
      var that = this
      this.$confirm({
        title: '确认支付?',
        content: '此操作将确认支付，状态将变为"维修中"，是否继续？',
        onOk() {
          that.$message.info('确认支付功能待实现', 3)
        },
        onCancel() {},
      })
    },

    handleFinishRepair(record) {
      this.$refs.completeRepairDrawer.init(record)
    },

    handleConfirmShipment(record) {
      this.$refs.confirmShipmentDrawer.init(record)
    },

    handleEndRepair(record) {
      var that = this
      this.$confirm({
        title: '工单完结',
        content: '确认完结该返修工单吗？',
        onOk() {
          return endRepair({ id: record.id })
            .then(() => {
              that.$message.success('操作成功')
              that.getList()
            })
            .catch(() => {
              // 错误处理
            })
        },
        onCancel() {},
      })
    },

    handleCancel(record) {
      var that = this
      this.$confirm({
        title: '取消订单',
        content: '确认取消该返修订单吗？',
        onOk() {
          return cancelRepair({ id: record.id })
            .then(() => {
              that.$message.success('操作成功')
              that.getList()
            })
            .catch(() => {
              // 错误处理
            })
        },
        onCancel() {},
      })
    },

    handleExport() {
      var that = this
      this.$confirm({
        title: '导出数据',
        content: '确认导出当前筛选条件下的所有数据吗？',
        onOk() {
          that.download(
            'fix/dev/repair/export',
            {
              ...that.queryParam,
            },
            `设备返修列表_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    handleDetail(record) {
      this.$refs.detailDrawer.init(record)
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        id: undefined,
        returnMailNo: undefined,
        mailNo: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids

      if (postIds.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }

      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '删除确认',
        content: '确认删除选中的数据吗？删除后将无法恢复。',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功')
          })
        },
        onCancel() {},
      })
    },

    onChangeTime(e) {
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  created() {
    this.getList()
  },
}
</script>

<style lang="less" scoped>
.text-ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
